import { RouteConfig } from '@/modules/core/app/helpers/RouteConfig';
import { Component } from 'vue';

export class AuthSsoLoginRouteConfig extends RouteConfig {
  async getComponent(): Promise<Component | null> {
    return import('/@/modules/auth/pages/SsoLoginPage.vue');
  }
}
